module.exports = __webpack_public_path__ + "static/media/LogoTextOnly.1240ba3e.svg";